module.exports = __webpack_public_path__ + "img/sk.c26a6f1d.png";